import CryptoJS from 'crypto-js';

const key = '6tZwR6zAcAkcj2NxMYOBuU1sCl8bphyH';
const parsedKey = CryptoJS.enc.Utf8.parse(key);

// 密码加密
export const encryptPwd = (content = '') => {
  const options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  };

  const encryptedData = CryptoJS.AES.encrypt(content, parsedKey, options);
  const encryptedBase64Str = encryptedData.toString();
  return encryptedBase64Str;
};

// 生成 auth 加密串
export const encryptAuth = (source = {}) => {
  // token不需要传递给后端，otherSource 为所有的参数。
  const { token, ...otherSource } = source;

  // 1. 所有参数，按字母顺序排序后，相加
  let str = Object.keys(otherSource)
    .sort()
    .reduce((prev, key) => prev + source[key], '');
  // 2. url 编码
  str = encodeURIComponent(str);
  // 3. 加上 token 和 key
  str = token + str + key;

  // md5 加密
  return CryptoJS.MD5(str).toString();
};
